import type { ICommand } from '@model-framework/command';
import type { ModelCommentThread, ModelCommentThreadRepository } from '../domain';
import type { ModelCommentContents } from '../domain/ModelCommentContents';
import type { IPositionSetRepository } from '@view-model/models/common/PositionSet';
import type { ModelCommentThreadId } from 'balus-common';
export class ModelCommentsDeleteCommand implements ICommand {
  constructor(
    private readonly commentContents: ModelCommentContents,
    private readonly threadRepository: ModelCommentThreadRepository,
    private readonly positionRepository: IPositionSetRepository
  ) {}

  private get threadIds(): ModelCommentThreadId[] {
    return this.commentContents.allIds();
  }

  do(): void {
    Promise.all([
      this.threadRepository.deleteMany(this.threadIds),
      this.positionRepository.deleteMany(this.threadIds),
    ]).then();
  }

  async canRedo(): Promise<boolean> {
    const currentThreads = await this.threadRepository.getMany(this.threadIds);
    return currentThreads.filter((thread: ModelCommentThread) => !!thread).length === this.threadIds.length;
  }

  async canUndo(): Promise<boolean> {
    const currentThreads = await this.threadRepository.getMany(this.threadIds);
    return currentThreads.filter((thread: ModelCommentThread) => !!thread).length === 0;
  }

  redo(): void {
    this.do();
  }

  undo(): void {
    const { threads, positions } = this.commentContents.contents();
    Promise.all([this.threadRepository.saveMany(threads.list()), this.positionRepository.saveMany(positions)]).then();
  }
}
